export default function About() {
        return (
                <main className="mx-auto max-w-[900px] px-6 lg:px-12 py-20">
                        <div className="overline text-[var(--ink-faint)] mb-6">
                                § Manual do arquivo
                        </div>
                        <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl tracking-normal leading-[0.95] text-[var(--ink)]">
                                Um arquivo
                                <br />
                                <span className="italic text-[var(--controversy)]">
                                        para leitores incomodados.
                                </span>
                        </h1>

                        <div className="mt-14 space-y-6 text-lg leading-relaxed text-[var(--ink)] font-serif">
                                <p>
                                        Verdade Oculta é um arquivo curado que cataloga
                                        controvérsias da vida pública portuguesa e disseca as
                                        estratégias narrativas que partidos, governos e órgãos
                                        de comunicação social utilizam para enquadrar essas
                                        controvérsias diante da opinião pública.
                                </p>
                                <p>
                                        Cada dossiê tem três camadas:{" "}
                                        <strong>factos verificáveis</strong> (com fontes citadas),{" "}
                                        <strong>narrativas em circulação</strong> (por linha
                                        editorial e bloco político), e uma{" "}
                                        <strong>análise transversal</strong> que aponta o que
                                        falta no debate público.
                                </p>
                                <p>
                                        A análise é feita por uma equipa de investigadores e curadores de informação. 
                                        Analisamos diariamente dezenas de fontes, discursos e documentos. Quando as narrativas
                                        divergem, a divergência é rigorosamente registada. Quando convergem em
                                        torno de um enquadramento unânime ou coordenado, esse enquadramento torna-se
                                        o próprio objecto da nossa análise.
                                </p>
                                <p>O projecto rege-se por três princípios:</p>
                                <ol className="list-decimal pl-6 space-y-3 text-[var(--ink)]">
                                        <li>
                                                <strong className="text-[var(--controversy)]">
                                                        Fonte sempre.
                                                </strong>{" "}
                                                Toda afirmação tem rasto verificável.
                                        </li>
                                        <li>
                                                <strong className="text-[var(--controversy)]">
                                                        Múltiplos lados.
                                                </strong>{" "}
                                                Reconhecemos que &ldquo;verdade oculta&rdquo; é, muitas vezes,
                                                perspectiva obliterada — não conspiração.
                                        </li>
                                        <li>
                                                <strong className="text-[var(--controversy)]">
                                                        Português europeu.
                                                </strong>{" "}
                                                A linguagem importa. Escrevemos para o leitor lusitano,
                                                com referências lusitanas.
                                        </li>
                                </ol>
                                <p className="text-[var(--ink-soft)] italic">
                                        Aviso legal: os conteúdos são análise crítica e jornalismo
                                        de opinião informada. Não constituem acusações jurídicas.
                                        Encorajamos a verificação independente.
                                </p>
                        </div>
                </main>
        );
}
